import React, {useEffect, useState} from "react";
import styles from "./index.less";
import {Card, message, Button, Flex, Tag, Spin, Modal} from "antd";
import HttpTool from "../../../tool/HttpTool";
import {CheckSquareFilled, CloseSquareFilled} from "@ant-design/icons";
import ModalBase from "../../../components/modalBase/index";
import APILXD from "../../../http/APILXD";
import VipPriceList from "./VipPriceList";
import Help from "../../../tool/Help";

const MB = new ModalBase();

export default function DeveloperVipSet(props) {
  const [loading, setLoading] = useState(false);
  const [vipConfig, setVipConfig] = useState();

  useEffect(() => {
    getVipConfig()
  },[])

  const getVipConfig = async () => {
    setLoading(true)
    HttpTool.post(APILXD.devVipList,(code,msg,data)=>{
      let formatData = {};
      data.forEach((eachItem)=>{
        if(eachItem.level === 0){
          formatData.normal = eachItem;
        }
        if(eachItem.level === 1){
          formatData.vip = eachItem;
        }
      })

      setVipConfig(formatData)
      setLoading(false)
    },(code,msg)=>{
      message.error(msg)
      setLoading(false)
    },{})
  }

  //获取权益表单项
  const getEditItem = (defaultData)=>{
    let defaultOption = {
      type: "inputNumber",
      ver: true,
      reg: (v)=>{
        return typeof v === "number" && v>=0
      },
      verMessage: "请配置数量",
      required: true,
    };
    let props = {
      colCount: 1,
      formItemLayout: {
        labelCol: { span: 10 },
        wrapperCol: { span: 12, offset: 0 },
      },
      parameterArr: [
        {
          ...defaultOption,
          field: "capCreateCount",
          name: "创建技能数量",
          option: {
            style: {width: "100%"},
            min: 0,
            max: 999999999,
            precision: 0,
            step: 1,
            addonAfter: '个',
            defaultValue: defaultData?.capCreateCount
          }
        },
        {
          ...defaultOption,
          field: "positionCreateCount",
          name: "创建职位数量",
          option: {
            style: {width: "100%"},
            min: 0,
            max: 999999999,
            precision: 0,
            step: 1,
            addonAfter: '个',
            defaultValue: defaultData?.positionCreateCount
          }
        },
        {
          ...defaultOption,
          field: "capCount",
          name: "使用线上技能数量",
          option: {
            style: {width: "100%"},
            min: 0,
            max: 999999999,
            precision: 0,
            step: 1,
            addonAfter: '个',
            defaultValue: defaultData?.capCount
          }
        },
        {
          ...defaultOption,
          field: "erpCount",
          name: "ERP自定义页面数量",
          option: {
            style: {width: "100%"},
            min: 0,
            max: 999999999,
            precision: 0,
            step: 1,
            addonAfter: '个',
            defaultValue: defaultData?.erpCount
          }
        },
        {
          ...defaultOption,
          field: "tableCount",
          name: "数据库可用",
          option: {
            style: {width: "100%"},
            min: 0,
            max: 999999999,
            precision: 0,
            step: 1,
            addonAfter: '张表',
            defaultValue: defaultData?.tableCount
          }
        },
        {
          ...defaultOption,
          field: "tableDataSize",
          name: "表格可存储",
          option: {
            style: {width: "100%"},
            min: 0,
            max: 999999999,
            precision: 0,
            step: 1,
            addonAfter: 'G',
            defaultValue: defaultData?.tableDataSize
          }
        },
        {
          ...defaultOption,
          field: "fileDataSize",
          name: "文件可存储",
          option: {
            style: {width: "100%"},
            min: 0,
            max: 999999999,
            precision: 0,
            step: 1,
            addonAfter: 'G',
            defaultValue: defaultData?.fileDataSize
          }
        },
        {
          ...defaultOption,
          field: "basicBlock",
          type: "switch",
          name: "基础拖块可用",
          reg: ()=>{
            return true
          },
          option: {
            defaultValue: defaultData?.basicBlock
          }
        },
        {
          ...defaultOption,
          field: "superBlock",
          type: "switch",
          name: "高级拖块可用",
          reg: () => {
            return true
          },
          option: {
            defaultValue: defaultData?.superBlock
          }
        }
      ],
    };
    return {
      props,
      otherParam: null
    }
  }


  //获取权益表单项
  const getEditItemForVip = (defaultData)=>{
    let defaultOption = {
      type: "inputNumber",
      ver: true,
      reg: (v)=>{
        return typeof v === "number" && v>=0
      },
      verMessage: "请配置数量",
      required: true,
    };
    let props = {
      colCount: 1,
      formItemLayout: {
        labelCol: { span: 10 },
        wrapperCol: { span: 12, offset: 0 },
      },
      parameterArr: [
        {
          ...defaultOption,
          field: "capCreateCount",
          name: "创建技能数量",
          option: {
            style: {width: "100%"},
            min: 0,
            max: 999999999,
            precision: 0,
            step: 1,
            addonAfter: '个',
            defaultValue: defaultData?.capCreateCount
          }
        },
        {
          ...defaultOption,
          field: "positionCreateCount",
          name: "创建职位数量",
          option: {
            style: {width: "100%"},
            min: 0,
            max: 999999999,
            precision: 0,
            step: 1,
            addonAfter: '个',
            defaultValue: defaultData?.positionCreateCount
          }
        },
        {
          ...defaultOption,
          field: "capCount",
          name: "使用线上技能数量",
          option: {
            style: {width: "100%"},
            min: 0,
            max: 999999999,
            precision: 0,
            step: 1,
            addonAfter: '个',
            defaultValue: defaultData?.capCount
          }
        },
        {
          ...defaultOption,
          field: "erpCount",
          name: "ERP自定义页面数量",
          option: {
            style: {width: "100%"},
            min: 0,
            max: 999999999,
            precision: 0,
            step: 1,
            addonAfter: '个',
            defaultValue: defaultData?.erpCount
          }
        },
        {
          ...defaultOption,
          field: "tableCount",
          name: "数据库可用",
          option: {
            style: {width: "100%"},
            min: 0,
            max: 999999999,
            precision: 0,
            step: 1,
            addonAfter: '张表',
            defaultValue: defaultData?.tableCount
          }
        },
        {
          ...defaultOption,
          field: "tableDataSize",
          name: "表格可存储",
          option: {
            style: {width: "100%"},
            min: 0,
            max: 999999999,
            precision: 0,
            step: 1,
            addonAfter: 'G',
            defaultValue: defaultData?.tableDataSize
          }
        },
        {
          ...defaultOption,
          field: "fileDataSize",
          name: "文件可存储",
          option: {
            style: {width: "100%"},
            min: 0,
            max: 999999999,
            precision: 0,
            step: 1,
            addonAfter: 'G',
            defaultValue: defaultData?.fileDataSize
          }
        },
        {
          ...defaultOption,
          field: "capKnowledgeCount",
          name: "技能知识库可上传知识",
          option: {
            style: {width: "100%"},
            min: 0,
            max: 999999999,
            precision: 0,
            step: 1,
            addonAfter: '个',
            defaultValue: defaultData?.capKnowledgeCount
          }
        },
        {
          ...defaultOption,
          field: "positionKnowledgeCount",
          name: "职位知识库可上传知识",
          option: {
            style: {width: "100%"},
            min: 0,
            max: 999999999,
            precision: 0,
            step: 1,
            addonAfter: '个',
            defaultValue: defaultData?.positionKnowledgeCount
          }
        },
        {
          ...defaultOption,
          field: "basicBlock",
          type: "switch",
          name: "基础拖块可用",
          reg: ()=>{
            return true
          },
          option: {
            defaultValue: defaultData?.basicBlock
          }
        },
        {
          ...defaultOption,
          field: "superBlock",
          type: "switch",
          name: "高级拖块可用",
          reg: () => {
            return true
          },
          option: {
            defaultValue: defaultData?.superBlock
          }
        }
      ],
    };
    return {
      props,
      otherParam: null
    }
  }

  //编辑普通会员权益
  const editEquityForNormal = (defaultData)=>{
    let addData = getEditItem(defaultData);
    MB.show(
      {
        title: "编辑普通开发者权益",
        okTitle: "确定",
        closeTitle: "取消",
        width: 500,
      },
      addData.props
      ,
      {
        url: APILXD.editDevVip,
        otherParam: {
          _id: defaultData._id
        },
        beforeSubmit: (param) => {
          return true;
        },
        callBack: (state, msg) => {
          //添加成功回调
          state === 'success' && getVipConfig();
        }
      });
  }

  //编辑vip会员权益
  const editEquityForVip = (defaultData)=>{
    let addData = getEditItemForVip(defaultData);
    MB.show(
      {
        title: "编辑Plus开发者权益",
        okTitle: "确定",
        closeTitle: "取消",
        width: 500,
      },
      addData.props
      ,
      {
        url: APILXD.editDevVip,
        otherParam: {
          _id: defaultData._id
        },
        beforeSubmit: (param) => {
          return true;
        },
        callBack: (state, msg) => {
          //添加成功回调
          state === 'success' && getVipConfig();
        }
      });
  }

  //编辑标签
  const editTagForVip = (defaultData)=>{
    MB.show(
      {
        title: "编辑Plus开发者标签",
        okTitle: "确定",
        closeTitle: "取消",
        width: 500,
      },
      {
        colCount: 1,
        formItemLayout: {
          labelCol: { span: 6 },
          wrapperCol: { span: 16, offset: 0 },
        },
        parameterArr: [
          {
            field: "tags",
            name: "会员标签",
            type: 'selectAll',
            selectType: 'value',
            required: false,
            ver: true,
            reg: (v) => {
              if(!v?.length){
                return true
              }

              return !(v.some((item) => {return item.length>6}))
            },
            verMessage: "每个标签最多使用6个字符",
            data: [],
            option: {
              mode: "tags",
              allowClear: true,
              placeholder: "请选择或填写标签",
              dropdownMatchSelectWidth: false,
              showSearch: true,
              onSearch: () => { },
              filterOption: (input, option) => {
                return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              },
              optionFilterProp: "children",
              defaultValue: defaultData?.tags?.length?defaultData?.tags.map((name)=>{
                return {
                  key: name,
                  value: name,
                  title: name
                }
              }):[]
            }
          },
        ],
      }
      ,
      {
        url: APILXD.editDevVip,
        otherParam: {
          _id: defaultData._id
        },
        beforeSubmit: (param) => {

          if(param.tags?.length){
            param.tags =  param.tags.map((item)=>{
              return typeof item === "string" ? item : item.value;
            });
          }
          return true;
        },
        callBack: (state, msg) => {
          //添加成功回调
          state === 'success' && getVipConfig();
        }
      });
  }


  //编辑价格
  const editPriceForVip = ()=>{
    Modal.info({
      title: "Plus开发者价格配置",
      width: "90vw",
      centered: true,
      maskClosable: false,
      closable: true,
      okText: "完成",
      content: <div
        style={{height: "70vh", position: "relative"}}
      >
        <VipPriceList
          {...props}
          productType={"dev_vip"}
        />
      </div>,
      afterClose: ()=>{
        getVipConfig()
      }
    })
  }

  //欠费额度
  const editOverduePayLimit = (defaultData, type)=>{
    MB.show(
      {
        title: `编辑${type==='normal'?"普通开发者":"Plus开发者"}欠费额度`,
        okTitle: "确定",
        closeTitle: "取消",
        width: 500,
      },
      {
        colCount: 1,
        formItemLayout: {
          labelCol: { span: 6 },
          wrapperCol: { span: 16, offset: 0 },
        },
        parameterArr: [
          {
            field: "overduePayLimitSet",
            name: "欠费额度",
            type: 'InputNumber',
            required: true,
            ver: true,
            verMessage: '请填写额度',
            reg: (v) => {
              return v && v>0
            },
            option: {
              placeholder: "请填写",
              style: {width: '100%'},
              precision: 0,
              min: 0,
              max: 999999,
              defaultValue: defaultData?.overduePayLimit/100
            }
          },
        ],
      }
      ,
      {
        url: APILXD.editDevVip,
        otherParam: {
          _id: defaultData._id
        },
        beforeSubmit: (param) => {
          param.overduePayLimit = param.overduePayLimitSet * 100
          return true;
        },
        callBack: (state, msg) => {
          //添加成功回调
          state === 'success' && getVipConfig();
        }
      });
  }

  return <div
    className={styles.fullPage}
  >
    <Spin
      spinning={loading}
    >
      <Flex gap={20} wrap={true}>
        <Card
          title={"普通开发者"}
          style={{ width: 500}}
        >
          <Flex
            gap={20}
            vertical={true}
          >
            <div>
              <div className={styles.cardItemTitle}>
                <div>会员权益</div>
                <Button
                  type={"link"}
                  onClick={()=>{
                    editEquityForNormal(vipConfig?.normal)
                  }}
                >编辑权益</Button>
              </div>
              <div>
                <CheckSquareFilled className={styles.check}/>创建技能数量 <span className={styles.vipItemValue}> {vipConfig?.normal?.capCreateCount} </span> 个
              </div>
              <div>
                <CheckSquareFilled className={styles.check}/>创建职位数量 <span className={styles.vipItemValue}> {vipConfig?.normal?.positionCreateCount} </span> 个
              </div>
              <div>
                <CheckSquareFilled className={styles.check}/>使用线上技能数量 <span className={styles.vipItemValue}> {vipConfig?.normal?.capCount} </span> 个
              </div>
              <div>
                <CheckSquareFilled className={styles.check}/>ERP自定义页面数量 <span className={styles.vipItemValue}> {vipConfig?.normal?.erpCount} </span> 个
              </div>
              <div>
                {
                  vipConfig?.normal?.basicBlock || vipConfig?.normal?.superBlock
                    ?<CheckSquareFilled className={styles.check}/>
                    :<CloseSquareFilled className={styles.notCheck}/>
                }

                {
                  vipConfig?.normal?.basicBlock
                    ?<span>基础拖块可用，</span>
                    :<span className={styles.forbiddenItem}>基础拖块不可用，</span>
                }
                {
                  vipConfig?.normal?.superBlock
                    ?<span>高级拖块可用</span>
                    :<span className={styles.forbiddenItem}>高级拖块不可用</span>
                }
              </div>
              <div>
                <CheckSquareFilled className={styles.check}/>数据库可用<span className={styles.vipItemValue}> {vipConfig?.normal?.tableCount} </span> 张表
              </div>
              <div>
                <CheckSquareFilled className={styles.check}/>表格可存储<span className={styles.vipItemValue}> {vipConfig?.normal?.tableDataSize} G</span>
              </div>
              <div>
                <CheckSquareFilled className={styles.check}/>文件可存储<span className={styles.vipItemValue}> {vipConfig?.normal?.fileDataSize} G</span>
              </div>
              <div>
                <CloseSquareFilled className={styles.notCheck}/>技能知识库可上传知识
              </div>
              <div>
                <CloseSquareFilled className={styles.notCheck}/>职位知识库可上传知识
              </div>
            </div>
            <div>
              <div className={styles.cardItemTitle}>
                <div>会员价格</div>
              </div>
              <div className={styles.priceBox}>
                <div>0 灵能</div>
              </div>
            </div>
            <div>
              <div className={styles.cardItemTitle}>
                <div>欠费额度</div>
                <Button
                  type={"link"}
                  onClick={()=>{
                    editOverduePayLimit(vipConfig?.normal, 'normal')
                  }}
                >编辑额度</Button>
              </div>
              <div style={{padding: '20px 10px'}}>{(vipConfig?.normal?.overduePayLimit||0)/100} 灵能</div>
            </div>
          </Flex>
        </Card>
        <Card
          title={"Plus开发者"}
          style={{ width: 500}}
        >
          <Flex
            gap={20}
            vertical={true}
          >
            <div>
              <div className={styles.cardItemTitle}>
                <div>会员权益</div>
                <Button
                  type={"link"}
                  onClick={()=>{
                    editEquityForVip(vipConfig?.vip)
                  }}
                >编辑权益</Button>
              </div>
              <div>
                <CheckSquareFilled className={styles.check}/>创建技能数量 <span className={styles.vipItemValue}> {vipConfig?.vip?.capCreateCount} </span> 个
              </div>
              <div>
                <CheckSquareFilled className={styles.check}/>创建职位数量 <span className={styles.vipItemValue}> {vipConfig?.vip?.positionCreateCount} </span> 个
              </div>
              <div>
                <CheckSquareFilled className={styles.check}/>使用线上技能数量 <span className={styles.vipItemValue}> {vipConfig?.vip?.capCount} </span> 个
              </div>
              <div>
                <CheckSquareFilled className={styles.check}/>ERP自定义页面数量 <span className={styles.vipItemValue}> {vipConfig?.vip?.erpCount} </span> 个
              </div>
              {
                vipConfig?.vip?.basicBlock || vipConfig?.vip?.superBlock
                  ?<CheckSquareFilled className={styles.check}/>
                  :<CloseSquareFilled className={styles.notCheck}/>
              }
              {
                vipConfig?.vip?.basicBlock
                  ?<span>基础拖块可用，</span>
                  :<span className={styles.forbiddenItem}>基础拖块不可用，</span>
              }
              {
                vipConfig?.vip?.superBlock
                  ?<span>高级拖块可用</span>
                  :<span className={styles.forbiddenItem}>高级拖块不可用</span>
              }
              <div>
                <CheckSquareFilled className={styles.check}/>数据库可用 <span className={styles.vipItemValue}> {vipConfig?.vip?.tableCount} </span> 张表
              </div>
              <div>
                <CheckSquareFilled className={styles.check}/>表格可存储 <span className={styles.vipItemValue}> {vipConfig?.vip?.tableDataSize} G</span>
              </div>
              <div>
                <CheckSquareFilled className={styles.check}/>文件可存储 <span className={styles.vipItemValue}> {vipConfig?.vip?.fileDataSize} G</span>
              </div>
              <div>
                <CheckSquareFilled className={styles.check}/>技能知识库可上传知识 <span className={styles.vipItemValue}> {vipConfig?.vip?.capKnowledgeCount} 个</span>
              </div>
              <div>
                <CheckSquareFilled className={styles.check}/>职位知识库可上传知识 <span className={styles.vipItemValue}> {vipConfig?.vip?.positionKnowledgeCount} 个</span>
              </div>
            </div>
            <div>
              <div className={styles.cardItemTitle}>
                <div>会员价格</div>
                <Button
                  type={"link"}
                  onClick={()=>{
                    editPriceForVip(vipConfig?.vip)
                  }}
                >编辑价格</Button>
              </div>
              {
                vipConfig?.vip?.pricePackageList?.length
                  ?(vipConfig?.vip?.pricePackageList?.sort((a,b)=>{return a.monthLimit - b.monthLimit})?.map((item, index) => {
                    return <div
                      key={'t_' + index}
                      className={styles.priceBox}
                    >
                      <div
                      >
                        {item.price/100} 灵能
                      </div>
                      <div
                      >
                        {Help.getDurationTimeShow(item.monthLimit,item.monthLimitUnit)}
                      </div>
                    </div>
                  }))
                  : "暂未配置"
              }
            </div>
            <div>
              <div className={styles.cardItemTitle}>
                <div>会员标签</div>
                <Button
                  type={"link"}
                  onClick={()=>{
                    editTagForVip(vipConfig?.vip)
                  }}
                >编辑标签</Button>
              </div>
              {
                vipConfig?.vip?.tags?.length
                  ?vipConfig?.vip?.tags.map((name)=>{
                    return <Tag color={"darkorange"}>{name}</Tag>
                  })
                  :'无标签'
              }
            </div>
            <div>
              <div className={styles.cardItemTitle}>
                <div>欠费额度</div>
                <Button
                  type={"link"}
                  onClick={()=>{
                    editOverduePayLimit(vipConfig?.vip, 'vip')
                  }}
                >编辑额度</Button>
              </div>
              <div style={{padding: '20px 10px'}}>{(vipConfig?.vip?.overduePayLimit || 0)/100} 灵能</div>
            </div>
          </Flex>
        </Card>
      </Flex>
    </Spin>
  </div>
}